module.exports = __webpack_public_path__ + "static/05-8923c0be25492456c6ae5fedd485d7d9.jpg";